"use client";
import { useRef as n, useMemo as A, useCallback as y, useEffect as k } from "react";
import { useCommandState as H } from "../../atoms/cmdk/index.js";
import { useSearchEvents as M } from "../../providers/search-events-provider.js";
import { useInkeepConfig as x } from "../../providers/config-provider.js";
import { graphqlRequest as N } from "../../utils/graphql-client.js";
import O from "./search-query.graphql.js";
import { useSearch as $ } from "./search-provider.js";
const j = 400, V = () => {
  const { setResultsList: c, setLoading: u, showSearchResults: a, setShowSearchResults: i } = $(), { baseSettings: L, searchSettings: U } = x(), { apiKey: R, aiApiBaseUrl: B, userAuthToken: l, filters: d } = L, { maxResults: p, debounceTimeMs: S, onQueryChange: F, filters: w } = U, { logEvent: T } = M(), t = n({}), h = n(null), m = n(null), Q = `${B}/graphql`, b = A(
    () => ({
      Authorization: `Bearer ${R}`,
      "Content-Type": "application/json",
      ...l ? { "User-Token": l } : {}
    }),
    [R, l]
  ), g = y(
    async (e) => {
      const r = new AbortController();
      h.current = r;
      try {
        const v = (await N(
          Q,
          O,
          { searchInput: e },
          b,
          r.signal
        ))?.search.searchHits;
        t.current[e.searchQuery] = v, c(v);
      } catch (q) {
        if (q.name === "AbortError")
          return;
      } finally {
        u(!1);
      }
    },
    [Q, b]
  ), C = y((e) => {
    const r = t.current[e.searchQuery];
    T({
      eventName: "search_query_response_received",
      properties: {
        searchQuery: e.searchQuery,
        totalResults: r?.length
      }
    });
  }, []), _ = () => {
    h.current && (h.current.abort(), u(!1));
  }, E = y(
    (e) => {
      if (m.current && window.clearTimeout(m.current), !e.searchQuery) {
        _(), c([]);
        return;
      }
      m.current = window.setTimeout(() => {
        _(), T({
          eventName: "search_query_submitted",
          properties: {
            searchQuery: e.searchQuery
          }
        }), t.current[e.searchQuery] ? (c(t.current[e.searchQuery]), C(e)) : (u(!0), g(e).then(() => {
          C(e);
        }));
      }, S);
    },
    [S, g]
  ), s = H((e) => e.search), f = A(
    () => ({
      searchQuery: s,
      filters: {
        ...d,
        ...w,
        limit: p
      }
    }),
    [s, p, d, w]
  ), o = n(null);
  k(() => {
    const e = () => {
      o.current !== null && (window.clearTimeout(o.current), o.current = null);
    }, r = !!s;
    return r && !a ? (e(), o.current = window.setTimeout(() => {
      i(!0);
    }, j)) : !r && a && (e(), i(!1)), e;
  }, [s, a, i]), k(() => {
    F?.(f.searchQuery), E(f);
  }, [E, f]);
};
export {
  V as useSearchFetch
};
